<div class="white-box main-black">
	<!-- Filters and Export Button -->
	<div class="filter-row py-4 mt-4 p-4 border-radius align-items-end">
		<div class="filter-item">
			<label for="period">{{"perf_analytic.period" | translate}}</label>
			<ng-select
				id="period"
				class="select"
				[items]="periods"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'g.durations' | translate"
				[(ngModel)]="filters.selectedPeriod"
				(change)="formatUtilizationData()"
			></ng-select>
		</div>

		<!-- Truck Type filter -->
		<div class="filter-item">
			<label for="truckTypeSelect">{{"devices.truck_type" | translate}}</label>
			<ng-select
				id="truckTypeSelect"
				class="select"
				[items]="truckTypesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.truck_type' | translate"
				[(ngModel)]="filters.selectedTruckType"
				(change)="formatUtilizationData()"
			></ng-select>
		</div>

		<!-- Manufacturer filter -->
		<div class="filter-item">
			<label for="manufacturerSelect">{{"devices.truck_manufacturer" | translate}}</label>
			<ng-select
				id="manufacturerSelect"
				class="select"
				[items]="manufacturersOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.truck_manufacturer' | translate"
				[(ngModel)]="filters.selectedManufacturer"
				(change)="formatUtilizationData()"
			></ng-select>
		</div>

		<!-- Vintage filter -->
		<div class="filter-item">
			<label for="vintageSelect">{{"devices.truck_vintage" | translate}}</label>
			<ng-select
				name="vintageSelect"
				id="vintageSelect"
				class="select"
				[multiple]="true"
				[items]="vintageOptions"
				[addTag]="true"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.truck_vintage' | translate"
				[(ngModel)]="filters.selectedVintage"
				(change)="vintageSelectionChanged()"
			>
				<ng-template ng-label-tmp let-item="item" let-clear="clear">
					<span>
						<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
						<span class="ng-value-label">{{item.label}}</span>
					</span>
				</ng-template>
			</ng-select>
		</div>

		<!-- Export Button -->
		<div class="filter-export">
			<button class="btn btn-primary" (click)="exportReports()">{{'g.export' | translate}}</button>
		</div>
	</div>

	<!-- Truck Utilization Metrics -->
	<div class="mt-4 px-4">
		<h4 class="mb-4">{{'utilization_metrics.truck_exception_metrics' | translate}}</h4>
		
		<div class="metrics-row" *ngIf="!isNoData">
			<app-utilization-metric-box
				class="ml-4"
				[title]="'utilization_metrics.asset_utilization_performance' | translate"
				[icon]="'fa fa-line-chart'"
				[items]="assetUtilization"
				(metricClicked)="commonService.scrollToWidget($event)"
			></app-utilization-metric-box>

			<app-utilization-metric-box
				[title]="'battery_performance.title' | translate"
				[icon]="'fa fa-warning'"
				[theme]="'yellow'"
				[items]="performance"
				[customSeverity]="{ critical: 25, high: 15, moderate: 10}"
				(metricClicked)="commonService.scrollToWidget($event)"
			></app-utilization-metric-box>
		</div>

		<!-- Legend Section -->
		<div class="legend-section ml-3 mt-4" *ngIf="!isNoData">
			<div class="legend-container">
				<div class="legend-title">{{ 'utilization_metrics.exception_severity_guide' | translate }}</div>
				<div class="legend-groups">
					<div class="legend-group" *ngFor="let group of metricsLegends">
						<div class="legend-group-title">{{ group.title }}</div>
						<div class="legend-item" *ngFor="let item of group.items">
							<span
								class="legend-symbol"
								[ngClass]="[
									item.type || 'dot',
									item.severity || item.colorClass
								]"
							></span>
							<span class="legend-label">{{ item.label }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>


	<div class="card-body pt-0" *ngIf="isNoData">
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</div>

	<app-exception-report-widget
		id="widget-low_truck_utilization"
		[widgetConfig]="widgetsConfig.low_truck_utilization"
		[devices]="devices"
		[data]="lowTruckUtilization"
		[filters]="filters"
	></app-exception-report-widget>

	<app-exception-report-widget
		id="widget-low_truck_energy_usage"
		[widgetConfig]="widgetsConfig.low_truck_energy_usage"
		[devices]="devices"
		[data]="lowTruckEnergyUsage"
		[filters]="filters"
	></app-exception-report-widget>

	<app-exception-report-widget
		id="widget-trucks_with_deep_discharge"
		[widgetConfig]="widgetsConfig.trucks_with_deep_discharge"
		[devices]="devices"
		[data]="trucksWithDeepDischarge"
		[filters]="filters"
	></app-exception-report-widget>

	<app-exception-report-widget
		id="widget-trucks_with_potential_weak_battery_cells"
		[widgetConfig]="widgetsConfig.trucks_with_potential_weak_battery_cells"
		[devices]="devices"
		[data]="trucksWithPotentialWeakBatteryCells"
		[filters]="filters"
	></app-exception-report-widget>

</div>

<div class="main-black border-radius-bottom white-box">
	<app-exception-report-widget
		id="widget-trucks_outside_geofence"
		[widgetConfig]="widgetsConfig.trucks_outside_geofence"
		[devices]="devices"
		[data]="[]"
		[filters]="filters"
	></app-exception-report-widget>
</div>